export class NICESecurityProfile {

    roleId: number;
    securityProfileId: number;
    securityProfileName: string;
    description: string;
    securityProfileStatusName: string;
    isInternal: boolean;
    // permissions: any[];
    // dataRestrictions: any[];

    constructor(securityProfile?) {
        this.roleId = securityProfile.roleId || 0;
        this.securityProfileId = securityProfile.securityProfileId || 0;
        this.securityProfileName = securityProfile.SecurityProfileName || '';
        this.description = securityProfile.description || '';
        this.securityProfileStatusName = securityProfile.SecurityProfileStatusName || 'True';
        this.isInternal = securityProfile.isInternal === true;
        // this.permissions = securityProfile.permissions || [];
        // this.dataRestrictions = securityProfile.dataRestrictions || [];
    }
}
